import MatchData from '../../data/MatchData'
import Match from '../Match/Match'
import { strToDate } from '../../utils/StringUtils'
import './MatchList.css'
import { useFilter } from '../../contexts/FilterContext'
import { useEffect, useState } from 'react'

const MatchList = () => {
  const [matchData, setMatchData] = useState(MatchData)
  const { selectedTeamId, selectedDate } = useFilter()

  useEffect(() => {
    setMatchData(
      MatchData.filter((dataItem) =>
        selectedTeamId
          ? dataItem.match_home_team_id === selectedTeamId ||
            dataItem.match_away_team_id === selectedTeamId
          : true
      )
        .filter((dataItem) =>
          selectedDate
            ? strToDate(dataItem.match_date).toDateString() === selectedDate
            : true
        )
        .sort((a, b) => {
          return strToDate(a.match_date) - strToDate(b.match_date)
        })
    )
  }, [selectedTeamId, selectedDate])

  return (
    <div className="matchList">
      {matchData.map((match) => (
        <Match key={match.match_id} match={match} />
      ))}
    </div>
  )
}

export default MatchList
